import React, { Component, Fragment, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from "react-router-dom"
import logo from '../../logo.svg'
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { CheckCircleTwoTone, SyncOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Layout, Form, Input, Button, Checkbox, Row, Col, Radio, Space, Spin, Image } from 'antd';
import { updatePassword, viewProcessSelector, clearState } from './resetPasswordSlice';
const { Header, Footer, Sider, Content } = Layout;
const { ReactDraggable: Draggable, ReactDOM } = window;


const layout = {
  wrapperCol: { span: 24, offset: 0 }
};

const tailLayout = {
  wrapperCol: { span: 24, offset: 0 }
};

const tailForgotLayout = {
  wrapperCol: { xs: { span: 24 }, sm: { span: 24, offset: 0 }, md: { span: 24, offset: 0 }, lg: { span: 24, offset: 0 } }
};

const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const ResetPassword = () => {

  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isToast, setToast] = React.useState(false);
  const [form] = Form.useForm();
  const [requiredMark, setRequiredMarkType] = useState('optional');

  const onRequiredTypeChange = ({ requiredMarkValue }) => {
    setRequiredMarkType(requiredMarkValue);
  };

  const [isLoading, setLoading] = React.useState(false);
  const [isResetSuccess, setResetSuccess] = React.useState(true);

  const { isFetching, isSuccess, isError, errorMessage, PassChanged } = useSelector(
    viewProcessSelector
  );

  useEffect(() => {
    setToast(false);
    dispatch(clearState());
    if (location.state && location.state.username && location.state.setPassKey) {
      setResetSuccess(true);
    }
    else {
      setResetSuccess(false);
      history.push({
        pathname: '/login',
        state: undefined,
      });
    }

  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }
    if (PassChanged) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      setResetSuccess(false);
      history.push({
        state: undefined,
      });
      // toast.success('Password reset successfully');
      dispatch(clearState());
    }
  }, [isError, isSuccess, setLoading, setToast, PassChanged]);


  const onFinish = (values) => {

    let data = {
      "username": location.state.username,
      "password": values.newpassword,
      "confirmPassword": values.confirmpassword,
      "setPassKey": location.state.setPassKey
    };

    //  console.log(data);
    setLoading(true);
    dispatch(updatePassword(data));
  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  const forStateClear = () => {
    history.push({
      pathname: '/login',
      state: undefined,
    });
  };

  return (
    <Layout className="layout">
      <Content className="content">
        <div className="auth-pages-bg-light">
          <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />

          {isToast &&
            <Toaster
              toastOptions={{
                className: '',
                style: {
                  border: '1px solid #713200',
                  padding: '16px',
                  color: '#713200',
                  marginTop: 50
                },
              }}
            >
              {(t) => (
                <ToastBar toast={t}>
                  {({ icon, message }) => (
                    <>
                      {icon}
                      {message}
                      {t.type !== 'loading' && (
                        <button onClick={() => toast.dismiss(t.id)}>X</button>
                      )}
                    </>
                  )}
                </ToastBar>
              )}
            </Toaster>
          }



          <Row style={{ width: '100%', height: '100%' }}>
            <Col span={9} >
              <div style={{ background: `url('./images/login-bg.png') center center /cover`, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Image
                  style={{ zIndex: 1 }}
                  preview={false}
                  // width={50}
                  // height={50}
                  // src="./images/logo.png"
                  src="./images/newLogo.png"
                />
              </div>
            </Col>

            {isResetSuccess ? (<>

              <Col span={15} style={{ paddingBottom: 100 }}>
                <div className="login-page-middle-sec">
                  {/* <Row className="form-row">

                  <Col md={{ span: 14, offset: 6 }} sm={{ span: 12, offset: 6 }} xs={{ span: 12, offset: 6 }}> */}
                  {/* <h1 style={{marginBottom:0,fontSize:28,fontWeight:300}}>Welcome to</h1> */}


                  <h2 className="form-row-h1">Reset Password</h2>
                  <h2>As you've logged in for the first time.It is Highly Recommended that you change your password for security reasons.</h2>


                  <Form
                    className="login-form"
                    {...layout}
                    name="basic"
                    layout="vertical"
                    initialValues={{
                      requiredMarkValue: requiredMark,
                    }}
                    onValuesChange={onRequiredTypeChange}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                  >



                    <Form.Item
                      label="New Password"
                      name="newpassword"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter new password',
                        },
                        { min: 8, message: 'Password must have a minimum length of 8' },
                        {
                          pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'),
                          message: 'Password must contain at least one lowercase letter, uppercase letter, number, and special character'
                        }
                      ]}
                      requiredMark={'optional'}
                      // hasFeedback
                      style={{ marginTop: 40 }}
                    >
                      <Input.Password
                        placeholder={"Enter password"} value="" autoComplete="off"
                        className="formInput"
                        iconRender={visible => (visible ? <EyeTwoTone style={{ color: '#000', fontSize: 24 }} /> : <EyeInvisibleOutlined style={{ color: '#000', fontSize: 24 }} />)}
                      />
                    </Form.Item>


                    <Form.Item
                      label="Confirm Password"
                      name="confirmpassword"
                      requiredMark={'optional'}
                      dependencies={['newpassword']}
                      //  hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('newpassword') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('The two passwords that you entered do not match!'));
                          },
                        }),
                      ]}
                      style={{ marginTop: 40 }}
                    >
                      <Input.Password
                        placeholder={"Enter password"} value="" autoComplete="off"
                        className="formInput"
                        iconRender={visible => (visible ? <EyeTwoTone style={{ color: '#000', fontSize: 24 }} /> : <EyeInvisibleOutlined style={{ color: '#000', fontSize: 24 }} />)}
                      />
                    </Form.Item>




                    <Form.Item {...tailLayout} style={{ marginTop: 40 }}>
                      <Button htmlType="submit" type="primary" className="login-btn" block>
                        Confirm
                      </Button>
                    </Form.Item>




                  </Form>
                </div>



                {/* </Col>
                </Row> */}
              </Col>

            </>
            ) :
              (<>

                <Col span={15} style={{ paddingBottom: 220 }}>
                  <div className="login-page-middle-sec">
                    {/* <Row className="form-row">
                    <Col md={{ span: 14, offset: 6 }} sm={{ span: 12, offset: 6 }} xs={{ span: 12, offset: 6 }}> */}
                    <CheckCircleTwoTone twoToneColor="#52c41a" className="right-tick" />
                    <h1 className="form-row-h1" style={{ fontSize: "34px" }}>Reset Password Successfully</h1>
                    <Form.Item {...tailLayout} style={{ marginTop: 40 }}>
                      {/* <Link to="/login"> */}
                      <Button onClick={forStateClear} type="primary" className="login-btn" block>
                        Back to Login page
                      </Button>
                      {/* </Link> */}
                    </Form.Item>
                    {/* </Col>
                  </Row> */}
                  </div>
                </Col>


              </>)
            }

          </Row>
        </div>
      </Content>
    </Layout>

  );
};

export default ResetPassword;